import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String
  };

  async waive(event) {
    event.preventDefault();
    if (!this.hasUrlValue || this.element.dataset.loading === "true") return;

    const hasFeeListFrame = document.getElementById("school_fee_list") !== null;
    this.setLoadingState(true);

    try {
      const response = await fetch(this.urlValue, {
        method: "GET",
        headers: {
          Accept: "text/vnd.turbo-stream.html"
        },
        credentials: "same-origin"
      });

      const stream = await response.text();
      if (!response.ok) throw new Error(`Waive request failed: ${response.status}`);

      if (window.Turbo && typeof window.Turbo.renderStreamMessage === "function") {
        window.Turbo.renderStreamMessage(stream);
      }
      if (!hasFeeListFrame) {
        window.dispatchEvent(new CustomEvent("driving-school-student-payments-v2:refresh"));
      }
    } catch (error) {
      console.error(error);
      window.location.href = this.urlValue;
    } finally {
      this.setLoadingState(false);
    }
  }

  setLoadingState(isLoading) {
    this.element.dataset.loading = isLoading ? "true" : "false";
    this.element.style.pointerEvents = isLoading ? "none" : "";
    this.element.style.opacity = isLoading ? "0.6" : "";
    this.element.setAttribute("aria-disabled", isLoading ? "true" : "false");

    if (isLoading) {
      this.element.dataset.originalText = this.element.textContent.trim();
      this.element.textContent = "Waiving...";
      return;
    }

    if (this.element.dataset.originalText) {
      this.element.textContent = this.element.dataset.originalText;
    }
  }
}
